import { ConnectedTable } from './ConnectedTable';

export default ConnectedTable;
